// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef494ec8","453":"d5d38d07","732":"3ecf14ea","977":"d342f813"}[chunkId] + ".chunk.js";
};